import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { authService } from "../services/api";

const SupabaseCallback: React.FC = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [message, setMessage] = useState("Completing sign-in...");

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.substring(1) : hash);
    const accessToken = params.get("access_token");

    const complete = async () => {
      try {
        if (!accessToken) {
          setMessage("Missing access token");
          return;
        }
        const tokenRes = await authService.exchangeSupabaseToken(accessToken);
        localStorage.setItem("token", tokenRes.access_token);
        const userData = await authService.getCurrentUser();
        updateUser(userData);
        setMessage("Signed in with Google");
        navigate("/", { replace: true });
      } catch (e) {
        setMessage("Error completing sign-in");
      }
    };

    complete();
  }, [navigate, updateUser]);

  return (
    <div className="beat-container py-16">
      <div className="flex justify-center items-center">
        <div className="beat-spinner"></div>
        <span className="ml-3 text-newspaper-600">{message}</span>
      </div>
    </div>
  );
};

export default SupabaseCallback;
